import { jwtDecode } from "jwt-decode"
export const pricesHandleSubmit =  (items) => {
    const token = sessionStorage.getItem("token")
    const user = jwtDecode(token)
    
    //Alert if the file is empty.
    if(items.length === 0){
        alert("Please select at least one item.")
        return
    }

    for(let i = 0; i < items.length; i++){
        //Validating each field that is required
        // if(!items[i].date || !items[i].product_id || !items[i].product || !items[i].by_product || !items[i].by_product_id || !items[i].province || !items[i].province_id  || !items[i].district_id || !items[i].station_id || !items[i].station || !items[i].maximum || !items[i].minimum){
        //     alert("Please fill all the fields")
        //     return 
        // }

        //Checking if the number fields actually contain numbers
        for (let i = 0; i < items.length; i++) {
            if (isNaN(Number(items[i].minimum)) || 
                isNaN(Number(items[i].maximum)) || 
                isNaN(Number(items[i].station_id)) || 
                isNaN(Number(items[i].district_id)) || 
                isNaN(Number(items[i].province_id)) || 
                isNaN(Number(items[i].product_id)) || 
                isNaN(Number(items[i].by_product_id))) {
                alert("Please enter numbers only in the following column: minimum, maximum, and the id columns respectively. Alphanumeric will not be accepted.");
                return;
            }
        }
        

        // Validating minimum and maximum rows
        // if(Number(items[i].minimum) > Number(items[i].maximum)){
        //     alert('Minimum cannot be greater than maximum!')
        //     return 
        // }

        //Seller check: if availbale then add this
        if (items[i].seller) {
            items[i].seller = String(items[i].seller);
        }
        
        if (items[i].station_id) {
            items[i].station_id = String(items[i].station_id);
        }
        
        if (items[i].district_id) {
            items[i].district_id = String(items[i].district_id);
        }
        
        if (items[i].province_id) {
            items[i].province_id = Number(items[i].province_id);
        }
        
        if (items[i].product_id) {
            items[i].product_id = String(items[i].product_id);
        }
        
        if (items[i].by_product_id) {
            items[i].by_product_id = String(items[i].by_product_id);
        }
        
        //If available then dd this
        if(items[i].buyer){
            items[i].buyer = String(items[i].buyer)
        }

        //Check if quality type is there or not
        if(items[i].quality_type){
            items[i].quality_type = String(items[i].quality_type)
        }

        //Check if deal_type exists
        if(items[i].deal_type){
            items[i].deal_type = String(items[i].deal_type)
        }

        //Check if cents per pound exists
        if(items[i]['c/lbs']){
            items[i]['c/lbs'] = Number(items[i]['c/lbs'])
        }

        //Check if bales exists
        if(items[i].bales){
            items[i].bales = Number(items[i].bales)
        }

        //Check if mill_id exists
        if(items[i].mill_id){
            items[i].bales = Number(items[i].bales)
        }

        //Check if mill name exists
        if(items[i].mill_name){
            items[i].mill_name = String(items[i].mill_name)
        }

        //Check if do_price exists
        if(items[i].do_price){
            items[i].do_price = Number(items[i].do_price)
        }

        //Check wholesale
        if(items[i].wholesale){
            items[i].wholesale = Number(items[i].wholesale)
        }
        
        //check if retail_price does exists
        if(items[i].retail_price){
            items[i].retail_price = Number(items[i].retail_price)
        }

        //Check if delivered exists
        if(items[i].delivered){
            items[i].delivered = Number(items[i].delivered)
        }

        //Check if spot_price_central_punjab exists
        if(items[i].spot_price_central_punjab){
            items[i].spot_price_central_punjab = Number(items[i].spot_price_central_punjab)
        }

        //Check if spot_price_southern_punjab
        if(items[i].spot_price_southern_punjab){
            items[i].spot_price_southern_punjab = Number(items[i].spot_price_southern_punjab)
        }

        //Check if spot_price_northern_punjab
        if(items[i].spot_price_northern_punjab){
            items[i].spot_price_northern_punjab = Number(items[i].spot_price_northern_punjab)
        }

        //Convert the province to the right format.
        items[i].province_id = parseInt(items[i].province_id)

        //Append the username who has uploaded.
        items[i].user_name = user.userName
    }

    return items
}

/**
 * Amna's notes
 * "33" => 33
 * "33abc" => NaN
 * true => 1
 * 
 */